<template>
  <v-container
    id="login"
    class="fill-height"
    tag="section"
  >
    <v-row
      justify="center"
      no-gutters
    >
      <v-slide-y-transition appear>
        <base-material-card
          v-if="isLoaded"
          id="auth"
          color="#0051ff"
          light
          max-width="100%"
          width="400"
          class="px-5 pb-2 py-3 auth-card"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold">
                Авторизация
              </h1>
            </div>
          </template>
          <v-card-text
            ref="form"
            class="text-center mt-5"
          >
            <!-- Email -->
            <v-text-field
              v-model="email"
              v-validate="'required|email'"
              :error-messages="errors.collect('email')"
              label="E-mail"
              color="purple darken-2"
              data-vv-name="email"
              prepend-icon="mdi-email"
              clearable
              validate-on-blur
              required
            />
            <!-- Password -->
            <v-text-field
              ref="password"
              v-model="password"
              v-validate="'required|min:6'"
              prepend-icon="mdi-lock-outline"
              :append-icon="showPass ? 'visibility' : 'visibility_off'"
              :type="showPass ? 'text' : 'password'"
              :error-messages="errors.collect('password')"
              label="Пароль..."
              data-vv-name="password"
              class="input-group--focused"
              validate-on-blur
              color="purple darken-2"
              @click:append="showPass = !showPass"
            />

            <div v-if="isChangePassword">
              <v-text-field
                ref="changePassword"
                v-model="changePassword"
                v-validate="'required|min:6'"
                prepend-icon="mdi-lock-outline"
                :append-icon="showPass ? 'visibility' : 'visibility_off'"
                :type="showPass ? 'text' : 'password'"
                :error-messages="errors.collect('changePassword')"
                label="Пароль..."
                data-vv-name="changePassword"
                class="input-group--focused"
                validate-on-blur
                color="purple darken-2"
                @click:append="showPass = !showPass"
              />
            </div>

            <span class="d-flex col-12 mt-3">
              <a
                class="secondary--text ml-6 ml-sm-0"
                href="#"
                @click="toRecoveryPassword()"
              >
                Забыли пароль?
              </a>
              <a
                class="secondary--text ml-auto"
                @click="toRegister"
              >
                Зарегистрироваться
              </a>
            </span>

            <v-btn
              color="#0051ff"
              medium
              rounded
              class="v-btn--text mt-4 white--text"
              @click="submit"
            >
              Войти
            </v-btn>
          </v-card-text>
          <v-snackbar
            v-model="snackbar.isShow"
            class="register-snakbar"
            absolute
            top
            :color="snackbar.color"
            :timeout="snackbar.timeout"
          >
            <span>{{ snackbar.responseMessage }}</span>
            <v-icon dark>
              mdi-checkbox-marked-circle
            </v-icon>
          </v-snackbar>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
    import {AUTH_LOGOUT, AUTH_REQUEST} from '../../store/actions/auth'

    export default {
    $_veeValidate: {
      validator: 'new',
    },
    name: 'PagesLogin',
    inject: ['inviteRepository'],

    data: () => ({
      // иконка скрыть/показать пароль
      auth: true,
      show: false,
      email: '',
      password: '',
      showPass: false,
      lazy: false,
      isLoaded: false,
      isChangePassword: false,
      changePassword: '',
      hash: '',
      snackbar: {
        isShow: false,
        color: 'error',
        timeout: 5000,
        responseMessage: 'Ошибка попробуйте еще раз',
      },
      // Валидация
      dictionary: {
        custom: {
          email: {
            required: () => 'Введите email',
            email: 'Невалидный email',
          },
          password: {
            required: () => 'Введите пароль',
            min: 'Минимум 6 символов',
          },
        },
      },
    }),

    async created () {
      try {
        await this.$store.dispatch(AUTH_LOGOUT)
        await this.confirmRegistration(this.$route.query.hash, this.$route.query.is_success)
      } finally {
        this.isLoaded = true
      }
    },

    mounted () {
      this.$validator.localize('en', this.dictionary)
    },

    methods: {
      toRegister () {
        this.$router.push({ name: 'Register' })
      },

      toRecoveryPassword () {
        this.$router.push({ name: 'Recovery' })
      },

      login: async function () {
        try {
          await this.$store.dispatch(AUTH_REQUEST, { email: this.email, password: this.password })
          await this.$router.push('/')
        } catch ({ response }) {
          this.snackbar.isShow = true
          this.snackbar.responseMessage = response.data.message
        }
      },

      confirmLogin: async function () {
        if (this.password.trim() !== this.changePassword.trim()) {
          this.snackbar.isShow = true
          this.snackbar.responseMessage = 'Пароли не совпадают, проверьте и повторите попытку'
          return
        }

        try {
          await this.inviteRepository.changePassword({
            hash: this.hash,
            password: this.password,
            password_confirmation: this.changePassword,
          })
          await this.$store.dispatch(AUTH_REQUEST, { email: this.email, password: this.password })
          await this.$router.push('/')
        } catch ({ response }) {
          this.snackbar.isShow = true
          this.snackbar.responseMessage = response.data.message
        }
      },

      async submit () {
        const isValid = await this.$validator.validateAll()
        if (!isValid) {
          return
        }

        this.isChangePassword ? await this.confirmLogin() : await this.login()
      },

      async confirmRegistration (hash, isSuccess) {
        if (!hash) {
          return
        }

        this.hash = hash
        const data = await this.inviteRepository.confirmRegistration(hash, isSuccess)
        if (data.status === 204) {
          return
        }

        this.email = data.data.login
        this.isChangePassword = data.data.change_password
      },

      clear () {
        this.email = ''
        this.password = ''
        this.changePassword = ''
        this.hash = ''
        this.$validator.reset()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .pseudo {
    z-index: -2;
    position: relative;
  }

  .auth-card {
    @media (max-width: 992px) {
      max-width: 336px !important;
    }
  }

  #login {
    .v-snack.register-snakbar.v-snack--active.v-snack--absolute.v-snack--top {
      top: calc(50% - 80px);
      padding: 20px;
    }
  }
</style>
